import { createSlice } from "@reduxjs/toolkit";
import api from "../services/api";
import { checkToken } from "./Usuarios"


const initialCliente = [];
const initialSelect = {}
// localStorage.getItem("selectCli")
//   ? JSON.parse(localStorage.getItem("selectCli"))
//   : 0;

const clienteReduce = createSlice({
  name: "cliente",
  initialState: {
    dataCliente: initialCliente,
    selectCli: initialSelect,
    optionsSelect: []
  },
  reducers: {
    fetchCliente: (state, action) => {
      state.dataCliente = action.payload;
      let options = []
      action.payload.map((item)=>{
        options.push({label: item.nmCliente + ` (Lj-${item.codLoja}) `+'/'+` (CNPJ-${item.cgc})` , value: item.codCliente+'-'+item.codLoja})
        return null
      })
      state.optionsSelect = options

    },
    setCliente: (state, action) => {
      state.selectCli = action.payload;
      // localStorage.setItem("selectCli", JSON.stringify(action.payload));
    },

    delCliente: (state) => {
      state.selectCli = {}
    }

  },
});

export default clienteReduce.reducer;

///////////////////////////  Actions ///////////////////////////////

const { fetchCliente, setCliente, delCliente} = clienteReduce.actions;

export const getCliente = (codVendedor) => async (dispatch) => {
  try {
    await api
      .get("/clientes", {headers:{Authorization:`Bearer ${checkToken()}`}, params: {codVendedor, filter: 'nmCliente'}})
      .then((response) => dispatch(fetchCliente(response.data)));
  } catch (e) {
    return console.error(e.message);
  }
};

export const selectCliente = (idCliente, nmCliente) => async (dispatch) => {
  try {
    if(idCliente){
      await api
      .get("/clientes/", {
        headers: { Authorization: `Bearer ${checkToken()}` },
        params: {
          idCliente: idCliente.split('-')[0],
          idLoja: idCliente.split('-')[1],
          filter: 'nmCliente'
        }
      })
      .then((response) => dispatch(setCliente(response.data[0])));
    }else {
      await api
      .get("/clientes/", {headers:{Authorization:`Bearer ${checkToken()}`}, params: {idCliente: nmCliente.substring(0,6), filter: 'nmCliente'}})
      .then((response) => dispatch(setCliente(response.data[0])));
    }
  } catch (e) {
    return console.error(e.message);
  }
};

export const deleteCliente = () => async dispatch => {
  try {
    await dispatch(delCliente())
  }
  catch (e) {
      return console.error(e.message);
  }
}


// export const postCliente = (form, cb) => async dispatch => {
//   try {
//     // const params = new URLSearchParams([['limit', 10]]);
//     await api.post('/cliente', form)
//         .then((response) => dispatch(addCliente(response.data))).then(cb)
//   }
//   catch (e) {
//       return console.error(e.message);
//   }
// }

// export const putCliente = (form,cb) => async dispatch => {
//   try {
//     const params = new URLSearchParams([['idCliente ', form.idCliente]]);
//     await api.put(`/cliente/${form.idCliente}`, form, params)
//         .then((response) => dispatch(editCliente(response.data))).then(cb)
//   }
//   catch (e) {
//       return console.error(e.message);
//   }
// }

